// src/pages/controleBar/mesas/MesaConfSearch.js
// src/pages/mesas/MesaConfSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useMesaConf } from '../../../contexts/controleBar/mesas/MesaConfContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const MesaConfSearch = ({ show, onHide, onSelectMesaConf }) => {
    const { mesasConf } = useMesaConf();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            inputRef.current?.focus();
        }
    }, [show]);

    if (!show) return null;

    const filtered = mesasConf.filter(m =>
        (m.codigo || '').toLowerCase().includes(filter.toLowerCase())
    );

    const sorted = [...filtered].sort((a, b) => {
        if (sortField === 'id') return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        if (sortField === 'codigo') {
            return sortDirection === 'asc'
                ? (a.codigo || '').localeCompare(b.codigo || '')
                : (b.codigo || '').localeCompare(a.codigo || '');
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (item) => {
        onSelectMesaConf(item);
        onHide();
    };

    return (
        <ModalContainer show={show} zIndex={1060} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Configuração de Mesa" onHide={onHide} />

            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por código..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sorted} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Id {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" style={{ width: '60%' }} aria-sort={sortField === 'codigo' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('codigo')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Código {sortField === 'codigo' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" style={{ width: '20%' }}>
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(item => (
                            <tr key={item.id} onDoubleClick={() => handleDoubleClick(item)}>
                                <td className="text-end align-middle">{item.id}</td>
                                <td className="text-start align-middle">{item.codigo}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectMesaConf(item)} style={{ padding: '2px 6px' }} label={item.codigo} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>

            <ModalFooter>

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default MesaConfSearch;